import script from "./PoliticaPrivacidadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoliticaPrivacidadView.vue?vue&type=script&setup=true&lang=ts"

import "./PoliticaPrivacidadView.vue?vue&type=style&index=0&id=6bd81992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd81992"]])

export default __exports__